import { ICD10 } from '../Shared/ICD10.model';

export default interface ISdohSingleAnswer {
    Answer: string;
    ICD10: ICD10 | null;
    LoincCode: string;
    Diagnosis: string;
}

export class SdohSingleAnswer implements ISdohSingleAnswer {
    Answer: string;
    ICD10: ICD10 | null;
    LoincCode: string;
    Diagnosis: string;

    constructor() {
        this.Answer = '';
        this.ICD10 = null;
        this.LoincCode = '';
        this.Diagnosis = '';
    }
}
